<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form @submit.prevent="store(0)" novalidate>
                <div class="modal-header">
                    <button type="button" class="close" aria-hidden="true" @click="goBack()">×</button>
                    <h4 class="modal-title">{{ $t('add_lead_deal') }}</h4>
                </div>
                <div class="modal-body">
                    <div class="modal_deal p_bottom_15">
                        <div class="row">

                            <!-- Consultant -->
                            <div class="col-xs-12 col-sm-4 m_bottom_15" :class="{'has-error': errors['deal.member_id']}">
                                <h5 class="m-t-0"><i class="fa-fw md-headset-mic"></i> {{ $t('consultant') }}</h5>
                                <pml-select-members v-model="deal.member_id" :removeFromOptions="deal.follower_id" :only-active="true"></pml-select-members>
                                <span class="error" v-if="errors['deal.member_id']">{{ errors['deal.member_id'][0] }}</span>
                            </div>

                            <!-- Follower -->
                            <div class="col-xs-12 col-sm-4 m_bottom_15" :class="{'has-error': errors['deal.follower_id']}">
                                <h5 class="m-t-0"><i class="fa-fw fa fa-location-arrow"></i> {{ $t('follower') }}</h5>
                                <pml-select-members v-model="deal.follower_id" :removeFromOptions="deal.member_id" :only-follow="true"></pml-select-members>
                                <span class="error" v-if="errors['deal.follower_id']">{{ errors['deal.follower_id'][0] }}</span>
                            </div>

                            <!-- Pipeline -->
                            <div class="col-xs-12 col-sm-4 m_bottom_15" :class="{'has-error': errors['deal.pipeline_step_id']}">
                                <h5 class="m-t-0"><i class="fa-fw fa fa-toggle-right"></i> {{ $t('pipeline') }}</h5>
                                <pml-select-group v-model="deal.pipeline_step_id" :options="pipelines" group-values="steps" group-label="name" class="select_pipeline"></pml-select-group>
                                <span class="error" v-if="errors['deal.pipeline_step_id']">{{ errors['deal.pipeline_step_id'][0] }}</span>
                            </div>

                        </div>
                    </div>

                    <!-- Infos -->
                    <div class="modal_deal">
                        <h5 class="m-t-0"><i class="fa-fw fa fa-info-circle"></i> {{ $t('info') }}</h5>
                        <div class="row">
                            <div class="col-xs-12 m_bottom_15" :class="{'has-error': errors['interests']}">
                                <label>{{ $t('interests') }} <small class="text-muted">({{ $t('press_enter_or_tab_to_register') }})</small></label>
                                <pml-autocomplete-tag-input :url="'/deals/interests'" v-model="deal.interests" :unfilteredTags="deal.interests"></pml-autocomplete-tag-input>
                                <span class="error" v-if="errors['deal.interests']">{{ errors['deal.interests'][0] }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['deal.source_id']}">
                                <label>{{ $t('source') }}</label>
                                <pml-select v-model="deal.source_id" :options="sources()"></pml-select>
                                <span class="error" v-if="errors['deal.source_id']">{{ errors['deal.source_id'][0] }}</span>
                            </div>
                            <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['deal.segment_id']}">
                                <label>{{ $t('segment') }}</label>
                                <pml-select v-model="deal.segment_id" :options="segments()"></pml-select>
                                <span class="error" v-if="errors['deal.segment_id']">{{ errors['deal.segment_id'][0] }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12" :class="{'has-error': errors['comments']}">
                                <label>{{ $t('comments') }} <small class="text-muted">({{ $t('deal') }})</small></label>
                                <textarea class="form-control autogrow" v-model="deal.comments" v-pml-autosize></textarea>
                                <span class="error" v-if="errors['deal.comments']">{{ errors['deal.comments'][0] }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Lead -->
                    <div class="modal_deal p_bottom_15">
                        <h5 class="m-t-0"><i class="fa-fw ti-user"></i> {{ $t('lead') }}</h5>

                        <!-- Select Lead -->
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="select_search m_bottom_15" :class="{'has-error': errors['deal.lead_id']}">
                                    <vue-multiselect
                                        v-model="selectedLead"
                                        :id="`select_${_uid}`"
                                        :options="leadOptions"
                                        :allow-empty="false"
                                        :placeholder="$t('search_lead') + `...`"
                                        :custom-label="customLabel"
                                        :block-keys="['Tab']"
                                        selectLabel=""
                                        selectedLabel=""
                                        deselectLabel=""
                                        label="email"
                                        track-by="id"
                                        :searchable="true"
                                        :loading="isLoading"
                                        :internal-search="false"
                                        :clear-on-select="true"
                                        :close-on-select="true"
                                        :options-limit="300"
                                        :limit="3"
                                        :show-labels="true"
                                        @search-change="asyncFind"
                                    >
                                        <template slot="option" slot-scope="props">
                                            <div class="clearfix d_flex w_full">
                                                <div class="min_w_50">
                                                    <img class="img-circle thumb-40" :src="props.option.avatar || `/static/images/avatar.jpg`">
                                                </div>
                                                <div>
                                                    <p class="option__title t_overflow bold m-0" v-if="props.option.full_name">{{ props.option.full_name }}</p>
                                                    <small class="option__small show t_overflow" v-if="props.option.email">{{ props.option.email }}</small>
                                                </div>
                                            </div>
                                        </template>
                                        <p slot="noResult" class="p-10 m-0"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</p>
                                    </vue-multiselect>
                                    <span class="error" v-if="errors['deal.lead_id']">{{ errors['deal.lead_id'][0] }}</span>
                                    <div class="clearfix" v-if="selectedLead">
                                        <div class="p-10">
                                            <div class="row">
                                                <div class="col-xs-12 col-sm-6 col-md-7">
                                                    <div class="d_table w_full">
                                                        <div class="d_t_cell w_50">
                                                            <a :href="`/leads/${selectedLead.id}`" target="_blank" class="pull-left m-r-10">
                                                                <img class="img-circle thumb-md" :src="selectedLead.avatar || `/static/images/avatar.jpg`">
                                                            </a>
                                                        </div>
                                                        <div class="d_t_cell">
                                                            <a :href="`/leads/${selectedLead.id}`" target="blank">
                                                                <p class="option__title bold m-0 f_size_14">{{ selectedLead.full_name }}</p>
                                                            </a>
                                                            <small class="option__small c_default show bold">{{ selectedLead.email }}</small>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xs-12 col-sm-6 col-md-5">
                                                    <div class="m-t-15 t_right">
                                                        <b class="m-r-10">{{ $t('deals') }}:</b>
                                                        <label class="label label-warning f_size_12" v-pml-tooltip="$t('open_as')"><i class="fa-fw fa fa-coffee"></i> {{ selectedLead.deals_counter.open }}</label>
                                                        <label class="label label-default f_size_12" v-pml-tooltip="$t('sold_as')"><i class="fa-fw fa fa-thumbs-up"></i> {{ selectedLead.deals_counter.sold }}</label>
                                                        <label class="label label-danger f_size_12" v-pml-tooltip="$t('lost_as')"><i class="fa-fw fa fa-thumbs-down"></i> {{ selectedLead.deals_counter.lost }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <a :href="`/leads/${selectedLead.id}`" target="blank" class="btn-sm btn btn-primary"><i class="fa-fw m-r-5 ti-user"></i> {{ $t('see_lead') }}</a>
                                        <a @click="clearSelectedLead" class="btn-sm btn btn-white"><i class="fa-fw m-r-5 fa fa-paint-brush"></i> {{ $t('remove_lead') }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Lead input -->
                        <div v-if="!selectedLead">
                            <div class="row">
                                <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['lead.first_name']}">
                                    <label>{{ $t('first_name') }}</label>
                                    <input type="text" class="form-control" v-model="lead.first_name">
                                    <span class="error" v-if="errors['lead.first_name']">{{ errors['lead.first_name'][0] }}</span>
                                </div>
                                <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['lead.last_name']}">
                                    <label>{{ $t('last_name') }}</label>
                                    <input type="text" class="form-control" v-model="lead.last_name">
                                    <span class="error" v-if="errors['lead.last_name']">{{ errors['lead.last_name'][0] }}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12 m_bottom_15" :class="[ emailAvailableClass() , { 'has-error': errors['lead.email'] } ]">
                                    <label class="input-group">
                                        <span class="input-group-addon" v-pml-tooltip="$t('email')"><i class="fa-fw fa fa-envelope"></i></span>
                                        <input type="email" class="form-control p-r-25" :placeholder="$t('email')" v-model="lead.email" @blur="checkEmail()" v-pml-block="isCheckingEmail">
                                    </label>
                                    <span class="error" v-if="errors['lead.email']">{{ errors['lead.email'][0] }}</span>
                                    <i class="fa fa-check check_mail"></i>
                                    <i class="fa fa-times check_mail"></i>
                                </div>
                            </div>

                            <!-- Button more info Lead -->
                            <div class="clearfix m-b-10">
                                <a href="javascript:;" class="btn btn-white" @click="showMore = !showMore"><i class="m-r-5 fa fa-plus-circle" :class="{ 'fa-minus-circle': showMore }"></i> {{ $t('lead_info') }}</a>
                            </div>

                            <!-- More info Lead -->
                            <div v-if="showMore">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['lead.phone']}">
                                        <label class="input-group">
                                            <span class="input-group-addon" v-pml-tooltip="$t('phone')"><i class="fa-fw fa fa-phone"></i></span>
                                            <input type="text" class="form-control" :placeholder="$t('phone')" v-model="lead.phone">
                                        </label>
                                        <span class="error" v-if="errors['lead.phone']">{{ errors['lead.phone'][0] }}</span>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['lead.mobile']}">
                                        <label class="input-group">
                                            <span class="input-group-addon" v-pml-tooltip="$t('mobile')"><i class="fa-fw fa fa-mobile"></i></span>
                                            <input type="text" class="form-control" :placeholder="$t('mobile')" v-model="lead.mobile">
                                        </label>
                                        <span class="error" v-if="errors['lead.mobile']">{{ errors['lead.mobile'][0] }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['lead.reference']}">
                                        <label>{{ $t('reference') }}</label>
                                        <input type="text" class="form-control" v-model="lead.reference">
                                        <span class="error" v-if="errors['lead.reference']">{{ errors['lead.reference'][0] }}</span>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['lead.country_id']}">
                                        <label>{{ $t('country') }}</label>
                                        <pml-select-countries v-model="lead.country_id" :value="lead.country_id"></pml-select-countries>
                                        <span class="error" v-if="errors['lead.country_id']">{{ errors['lead.country_id'][0] }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['lead.gender']}">
                                        <label>{{ $t('gender') }}</label>
                                        <pml-select v-model="lead.gender" :options="genders"></pml-select>
                                        <span class="error" v-if="errors['lead.gender']">{{ errors['lead.gender'][0] }}</span>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['lead.dob']}">
                                        <label>{{ $t('date_of_birth') }}</label>
                                        <pml-date-picker v-model="lead.dob" view-mode="years"></pml-date-picker>
                                        <span class="error" v-if="errors['lead.dob']">{{ errors['lead.dob'][0] }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12" :class="{'has-error': errors['lead.comments']}">
                                        <label>{{ $t('comments') }} <small class="text-muted">({{ $t('lead') }})</small></label>
                                        <textarea class="form-control autogrow" v-model="lead.comments" v-pml-autosize></textarea>
                                        <span class="error" v-if="errors['lead.comments']">{{ errors['lead.comments'][0] }}</span>
                                    </div>
                                </div>
                                <hr>
                                <h5 class="m-t-0"><i class="fa fa-home"></i> {{ $t('address') }}</h5>
                                <div class="row">
                                    <div class="col-xs-12 col-sm-7 col-md-8 m_bottom_15" :class="{'has-error': errors['lead.address']}">
                                        <label>{{ $t('address') }}</label>
                                        <input type="text" class="form-control" v-model="lead.address">
                                        <span class="error" v-if="errors['lead.address']">{{ errors['lead.address'][0] }}</span>
                                    </div>
                                    <div class="col-xs-12 col-sm-5 col-md-4 m_bottom_15" :class="{'has-error': errors['lead.zip_code']}">
                                        <label>{{ $t('zip_code') }}</label>
                                        <input type="text" class="form-control" v-model="lead.zip_code">
                                        <span class="error" v-if="errors['lead.zip_code']">{{ errors['lead.zip_code'][0] }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['lead.complement']}">
                                        <label>{{ $t('complement') }}</label>
                                        <input type="text" class="form-control" v-model="lead.complement">
                                        <span class="error" v-if="errors['lead.complement']">{{ errors['lead.complement'][0] }}</span>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['lead.district']}">
                                        <label>{{ $t('district') }}</label>
                                        <input type="text" class="form-control" v-model="lead.district">
                                        <span class="error" v-if="errors['lead.district']">{{ errors['lead.district'][0] }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6 m_md_bottom_15" :class="{'has-error': errors['lead.city']}">
                                        <label>{{ $t('city') }}</label>
                                        <input type="text" class="form-control" v-model="lead.city">
                                        <span class="error" v-if="errors['lead.city']">{{ errors['lead.city'][0] }}</span>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 m_md_bottom_15" :class="{'has-error': errors['lead.state']}">
                                        <label>{{ $t('state') }}</label>
                                        <input type="text" class="form-control" v-model="lead.state">
                                        <span class="error" v-if="errors['lead.state']">{{ errors['lead.state'][0] }}</span>
                                    </div>
                                </div>
                                <hr>
                                <h5 class="m-t-0"><i class="fa fa-link"></i> {{ $t('social_media') }}</h5>
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['lead.site']}">
                                        <label class="input-group">
                                            <span class="input-group-addon" v-pml-tooltip="$t('website')"><i class="fa-fw fa fa-desktop"></i></span>
                                            <input type="text" class="form-control" :placeholder="$t('website')" v-model="lead.site">
                                        </label>
                                        <span class="error" v-if="errors['lead.site']">{{ errors['lead.site'][0] }}</span>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['lead.skype']}">
                                        <label class="input-group">
                                            <span class="input-group-addon" v-pml-tooltip="'Skype'"><i class="fa-fw fa fa-skype"></i></span>
                                            <input type="text" class="form-control" placeholder="Skype" v-model="lead.skype">
                                        </label>
                                        <span class="error" v-if="errors['lead.skype']">{{ errors['lead.skype'][0] }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['lead.linkedin']}">
                                        <label class="input-group">
                                            <span class="input-group-addon" v-pml-tooltip="'LinkedIn'"><i class="fa-fw fa fa-linkedin"></i></span>
                                            <input type="text" class="form-control" placeholder="LinkedIn" v-model="lead.linkedin">
                                        </label>
                                        <span class="error" v-if="errors['lead.linkedin']">{{ errors['lead.linkedin'][0] }}</span>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['lead.facebook']}">
                                        <label class="input-group">
                                            <span class="input-group-addon" v-pml-tooltip="'Facebook'"><i class="fa-fw fa fa-facebook"></i></span>
                                            <input type="text" class="form-control" placeholder="Facebook" v-model="lead.facebook">
                                        </label>
                                        <span class="error" v-if="errors['lead.facebook']">{{ errors['lead.facebook'][0] }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['lead.gplus']}">
                                        <label class="input-group">
                                            <span class="input-group-addon" v-pml-tooltip="'Google+'" translate="false"><i class="fa-fw fa fa-google-plus"></i></span>
                                            <input type="text" class="form-control" placeholder="Google" v-model="lead.gplus">
                                        </label>
                                        <span class="error" v-if="errors['lead.gplus']">{{ errors['lead.gplus'][0] }}</span>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['lead.instagram']}">
                                        <label class="input-group">
                                            <span class="input-group-addon" v-pml-tooltip="'Instagram'"><i class="fa-fw fa fa-instagram"></i></span>
                                            <input type="text" class="form-control" placeholder="Instagram" v-model="lead.instagram">
                                        </label>
                                        <span class="error" v-if="errors['lead.instagram']">{{ errors['lead.instagram'][0] }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['lead.name']}">
                                        <label class="input-group">
                                            <span class="input-group-addon" v-pml-tooltip="'Twitter'"><i class="fa-fw fa fa-twitter"></i></span>
                                            <input type="text" class="form-control" placeholder="Twitter" v-model="lead.twitter">
                                        </label>
                                        <span class="error" v-if="errors['lead.twitter']">{{ errors['lead.twitter'][0] }}</span>
                                    </div>
                                    <div class="col-xs-12 col-sm-6" :class="{'has-error': errors['lead.pinterest']}">
                                        <label class="input-group">
                                            <span class="input-group-addon" v-pml-tooltip="'Pinterest'"><i class="fa-fw fa fa-pinterest"></i></span>
                                            <input type="text" class="form-control" placeholder="Pinterest" v-model="lead.pinterest">
                                        </label>
                                        <span class="error" v-if="errors['lead.pinterest']">{{ errors['lead.pinterest'][0] }}</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="p-15 t_right">
                    <span class="btn btn-white pull-left btn_mobile_block" ref="close" data-dismiss="modal">{{ $t('cancel') }}</span>
                    <a href="#" @click.prevent="store(1)" class="btn btn_green btn_mobile_block" v-pml-block="isSaving">{{ $t('save_and_go_to_deal') }}</a>
                    <button type="submit" class="btn btn-default btn_mobile_block" v-pml-block="isSaving">{{ $t('save') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import bus from '@/utils/events/bus'
    import Notify from '@/utils/helpers/notify'
    import RoutedModals from '@/utils/mixins/routed-modals'
    import { trans } from '@/utils/helpers/translation'
    import { create, createWithLead } from '@/services/deals'
    import { getAll } from '@/services/leads'
    import { mapGetters } from 'vuex'
    import { isEmpty, isNil, debounce, isNull } from 'lodash'

    export default {
        name: 'DealsCreate',
        mixins: [ RoutedModals ],
        data () {
            return {
                leadOptions: [],
                showMore: false,
                selectedLead: null,
                lead: {
                    country_id: null
                },
                deal: {
                    follower_id: null,
                    member_id: null,
                    segment_id: null,
                    source_id: null,
                    lead_id: null,
                    pipeline_step_id: null,
                    interests: []
                },
                errors: [],
                isSaving: false,
                isLoading: false,
                isCheckingEmail: false,
                isEmailAvailable: null
            }
        },
        metaInfo () {
            return {
                title: trans('create_a_deal')
            }
        },
        created () {
            this.deal.pipeline_step_id = this.verifyPipelineId()
        },
        beforeDestroy () {
            window.sessionStorage.removeItem('pipeline_action_pipeline_id')
        },
        computed: {
            ...mapGetters({
                'member': 'getMember',
                'activeMembers': 'getActiveMembers',
                'sources': 'getActiveSources',
                'segments': 'getActiveSegments',
                'pipelines': 'getPipelines',
                'genders': 'getGender'
            })
        },
        watch: {
            'selectedLead' (val) {
                if (val)
                    this.deal.lead_id = val.id
                else
                    this.deal.lead_id = null
            }
        },
        mounted () {
            this.deal.member_id = this.member.id
            this.deal.follower_id = null
        },
        methods: {
            asyncFind: debounce(function (query) {
                if (isEmpty(query)) return

                this.isLoading = true

                getAll({identity: query})
                    .then(response => {
                        this.leadOptions = response.data
                        this.isLoading = false
                    })
            }, 500),
            customLabel (opt) {
                let text = opt.full_name

                return isEmpty(opt.email) ? text : `${text} – (${opt.email})`
            },
            limitText (count) {
                return `and ${count} other countries`
            },
            checkEmail () {
                if (isEmpty(this.lead.email)) {
                    this.isEmailAvailable = null
                    return
                }

                this.isCheckingEmail = true

                getAll({ email: this.lead.email })
                    .then(response => {
                        this.isEmailAvailable = response.data.length === 0
                        this.errors['lead.email'] = this.isEmailAvailable ? '' : [ trans('lead_already_registered_use_field_to_find') ]
                    })
                    .then(() => { this.isCheckingEmail = false })
            },
            emailAvailableClass () {
                if (this.isEmailAvailable) return 'is-available'
                else if (this.isEmailAvailable === null) return ''
                else if (!this.isEmailAvailable) return 'is-not-available'
            },
            clearSelectedLead () {
                this.selectedLead = null
            },
            getRequest () {
                return isNil(this.deal.lead_id) ? createWithLead({ deal: this.deal, lead: this.lead }) : create(this.deal)
            },
            store (redirect) {
                this.isSaving = true

                this.getRequest()
                    .then(response => {
                        if (redirect) {
                            this.$router.push({ name: 'deals.show', params: { id: response.data.id } })
                        } else {
                            bus.$emit('doFilterDeals', 1)
                            bus.$emit('refreshDealsCard')
                        }
                        Notify.success(trans('_notifications.success'))
                        this.clear()
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors || []
                    })
                    .then(() => { this.isSaving = false })
            },
            clear () {
                this.selectedLead = null
                this.lead = {
                    country_id: null
                }
                this.deal = {
                    follower_id: null,
                    member_id: null,
                    segment_id: null,
                    source_id: null,
                    lead_id: null,
                    interests: []
                }
                this.errors = []
                if (this.verifyPipelineId())
                    window.sessionStorage.removeItem('pipeline_action_pipeline_id')
            },
            verifyPipelineId () {
                let verifyId = window.sessionStorage.getItem('pipeline_action_pipeline_id')

                if (typeof verifyId !== 'undefined' && !isNull(verifyId) && !isNaN(verifyId))
                    return parseInt(verifyId)

                return false
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/list/Create.vue